/**
 * What the membership covers, in the words carebywally.com uses. Kept here rather than fetched:
 * it is marketing copy that changes with the plan, not with the member, and no endpoint carries
 * a member's entitlements yet.
 */
export const INCLUDED = [
	'Unlimited cleanings and checkups',
	'Pain-free AIRFLOW cleanings',
	'3D scans and X-rays',
	'Custom at-home whitening',
	'No copays or deductibles',
]

/** Treatments a member can add, charged on their own. */
export const ADD_ONS = [
	'Curodont no-drill cavity treatment',
	'Periodontal therapy',
	'Clear aligners, retainers and nightguards',
]

/**
 * What Wally does not do, said plainly. Better a member reads it here than finds out in the
 * chair.
 */
export const NOT_INCLUDED =
	'We do not do restorative work like root canals, fillings or implants. If you need it, we will share your X-rays and help you find the right specialist.'
